import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { MessagingLogItem, TokeetMessagingSettingsResponse, UpdateTokeetMessagingSettingsPayload } from './model'
import { MessagingChannelKeys } from '../channel/model'
import { map } from 'rxjs/operators'
@Injectable()
export class MessagingSettingsService {
  constructor(private http: HttpClient) {}

  getSettings() {
    const url = `@api/account/tokeet-messaging-settings`

    return this.http.get<TokeetMessagingSettingsResponse>(url)
  }

  updateSettings(payload: UpdateTokeetMessagingSettingsPayload) {
    const url = `@api/account/tokeet-messaging-settings`

    return this.http.put<TokeetMessagingSettingsResponse>(url, { tokeet_messaging_recharge_settings: payload })
  }

  getLogs(channel: MessagingChannelKeys) {
    const url = `@api/v1/message/${channel}/logs/`
    return this.http
      .get<{ response: { data: MessagingLogItem[]; status: string } }>(url)
      .pipe(map((r) => r.response.data))
  }
}
